export default {
  LOAD_SEPOMEX_FILE_TO_VALIDATE: 'LOAD_SEPOMEX_FILE_TO_VALIDATE',
  SEPOMEX_FILE_VALIDATION_SUCCESS: 'SEPOMEX_FILE_VALIDATION_SUCCESS',
  LOAD_SEPOMEX_FILE_TO_IMPORT: 'LOAD_SEPOMEX_FILE_TO_IMPORT',
  SEPOMEX_FILE_IMPORT_SUCCESS: 'SEPOMEX_FILE_IMPORT_SUCCESS',
  CANCEL_LOAD_SEPOMEX_FILE: 'CANCEL_LOAD_SEPOMEX_FILE'
}
